export const ESOCIAL_TABELAS_URL =
  'https://www.gov.br/esocial/pt-br/documentacao-tecnica/leiautes-esocial-versao-s-1-3-nt-06-2026/tabelas.html';

export const ESOCIAL_GOLDEN_EMPREGADO_GERAL = '101';
export const ESOCIAL_GOLDEN_APRENDIZ = '103';
export const ESOCIAL_GOLDEN_ESTAGIARIO = '901';

export const ESOCIAL_GOLDEN_SALARIO = '1000';
export const ESOCIAL_GOLDEN_13_SALARIO = '5001';
export const ESOCIAL_GOLDEN_FERIAS = '1016';
export const ESOCIAL_GOLDEN_FGTS = '9908';

export const ESOCIAL_MIN_CATEGORIAS = 40;
export const ESOCIAL_MAX_CATEGORIAS = 55;

export const ESOCIAL_MIN_RUBRICAS = 200;
export const ESOCIAL_MAX_RUBRICAS = 220;
